// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Message = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Message = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Message = _exports.Message = function Message(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M6.25 14.3755C7.28516 14.3755 8.125 15.2153 8.125 16.2505V16.8755L10.957 14.7505C11.2812 14.5083 11.6758 14.3755 12.082 14.3755H17.5C17.8438 14.3755 18.125 14.0942 18.125 13.7505V2.50049C18.125 2.15674 17.8438 1.87549 17.5 1.87549H2.5C2.15625 1.87549 1.875 2.15674 1.875 2.50049V13.7505C1.875 14.0942 2.15625 14.3755 2.5 14.3755H6.25ZM8.125 19.2192L8.11719 19.2271L7.91797 19.3755L7.25 19.8755C7.0625 20.0161 6.80859 20.0396 6.59375 19.9341C6.37891 19.8286 6.25 19.6138 6.25 19.3755V18.5435V18.2935V18.2817V18.1255V16.2505H4.375H2.5C1.12109 16.2505 0 15.1294 0 13.7505V2.50049C0 1.12158 1.12109 0.000488281 2.5 0.000488281H17.5C18.8789 0.000488281 20 1.12158 20 2.50049V13.7505C20 15.1294 18.8789 16.2505 17.5 16.2505H12.082L8.125 19.2192Z",
      fill: "currentColor"
    }));
  };
});
